import React from 'react';
import PropTypes from 'prop-types';
import { StyleSheet, css } from '../../utility/paypalAphrodite';
import classNames from 'classnames';

const illustrations = {
  critical:
    'https://www.paypalobjects.com/paypal-ui/illustrations/svg/critical.svg',
  'more-info':
    'https://www.paypalobjects.com/paypal-ui/illustrations/svg/more-info.svg',
  'credit-cards':
    'https://www.paypalobjects.com/paypal-ui/illustrations/svg/credit-cards.svg',
  success:
    'https://www.paypalobjects.com/paypal-ui/illustrations/svg/success.svg',
  warning:
    'https://www.paypalobjects.com/paypal-ui/illustrations/svg/warning.svg',
};

const STYLES = StyleSheet.create({
  large: {
    width: 144,
  },
  medium: {
    width: 108,
  },
  small: {
    width: 72,
  },
});

export default function Illustration({ type, size, className, ...rest }) {
  if (!size) {
    size = 'large';
  }

  const classes = classNames(className, {
    [css(STYLES.large)]: size === 'large',
    [css(STYLES.medium)]: size === 'medium',
    [css(STYLES.small)]: size === 'small',
  });

  return <img src={illustrations[type]} className={classes} {...rest} />;
}

Illustration.propTypes = {
  type: PropTypes.string,
  size: PropTypes.string,
  className: PropTypes.string,
};
